import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/src/locale/pt";
import "@/assets/global.scss";
import listIcon from "./icons";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: listIcon,
  },
  breakpoint: {
    mobileBreakpoint: 550,
    scrollBarWidth: 8,
  },
  lang: {
    current: "pt",
    locales: { pt },
  },
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#5093FE",
        bg: "#f1f1f1",
        subtext: "#757575",
        error: "#FE5050",
        success: "#00F391",
        warning: "#FF8A00",
        secondary: "#E5E6E8",
        grey: "#B5B5B5",
        grey2: "#6C6C6C",
      },
      dark: {
        primary: "#5093FE",
        bg: "#161922",
        subtext: "#757575",
        error: "#FE5050",
        success: "#00F391",
        warning: "#FF8A00",
        secondary: "#252831",
        grey: "#B5B5B5",
        grey2: "#6C6C6C",
      },
    },
  },
});
